// 260822nrai: AZ / aggregation PDF integrity check in a reveal modal (multipart via FormData)

function azVerifyPdfModalEl() {
  return $('#az_verify_pdf_modal');
}

export function azVerifyPdfModalOpen() {
  const $modal = azVerifyPdfModalEl();
  if (!$modal.length) { return; }
  try { $modal.foundation('reveal', 'open'); } catch (e) {}
}

export function azVerifyPdfModalClose() {
  const $modal = azVerifyPdfModalEl();
  if (!$modal.length) { return; }
  try { $modal.foundation('reveal', 'close'); } catch (e) {}
}

export function initAzVerifyPdf() {
  $(document).on('submit', '#az_verify_pdf_form', function (event) {
    event.preventDefault();
    const form = this;
    if (typeof SetPageToBusy === 'function') { SetPageToBusy(); }
    $.ajax({
      url: form.action,
      type: 'POST',
      data: new FormData(form),
      processData: false,
      contentType: false,
      dataType: 'script',
      complete: function () {
        if (typeof SetPageToIdle === 'function') { SetPageToIdle(); }
      }
    });
  });
}
